export type WorkStatus = 'played' | 'ready' | 'study';
export type Visibility = 'private' | 'link' | 'public';

export interface Work {
  catalog: string;
  composer: string;
  title: string;
  status: WorkStatus;
}

export interface Engagement {
  date: string;   // YYYY-MM-DD
  venue: string;
  title: string;
  role: string;
}

export type RecordingKind = 'live' | 'studio';

export interface Recording {
  title: string;
  url: string;       // 외부 링크 (유튜브 등)
  kind: RecordingKind;
  date: string;      // YYYY-MM-DD, 비워도 됨
  duration: string;  // 14:32
}

export interface ProfileData {
  handle: string;
  nameLat: string;
  instrument: string;
  ensemble: string;
  tagline: string;
  bio: string;
  teachers: string;
  instrumentDetail: string;
  availConcerto: boolean;
  availChamber: boolean;
  availLesson: boolean;
  availRegion: string;
  availFrom: string; // YYYY-MM
  visibility: Visibility;
  updatedAt?: string;
  works: Work[];
  engagements: Engagement[];
  recordings: Recording[];
}

export interface AccountUser {
  id: number;
  email: string;
  name: string;
  instrument: string | null;
  kakao: boolean;
}

export const instruments = ['바이올린', '비올라', '첼로', '더블베이스', '피아노', '성악', '관악', '타악', '작곡·지휘', '기타'];

export const workStatusLabel: Record<WorkStatus, string> = {
  played: '연주',
  ready: '준비',
  study: '학습',
};

export const recordingKindLabel: Record<RecordingKind, string> = {
  live: '라이브',
  studio: '스튜디오',
};

export const visibilityLabel: Record<Visibility, string> = {
  private: '나만 보기',
  link: '링크를 아는 사람만',
  public: '전체 공개',
};

export const HANDLE_REGEX = /^[a-z0-9][a-z0-9._-]{1,28}[a-z0-9]$/;

// 로컬 기준 오늘 날짜 (YYYY-MM-DD). 이 날 이후 연주는 '이번 시즌'
export function todayString() {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
